import { Constants } from "../constants/constants";
import { Injectable } from "@angular/core";
import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";

import { Observable, of, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

import Swal from "sweetalert2/dist/sweetalert2.all.js"; //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI
import { Utils } from "../utils/utils";

@Injectable({
  providedIn: "root",
})
export class GestionVendedorService {
  constructor(private http: HttpClient, private utils: Utils) {}

  public getGestionVendedor(
    idUsuario,
    agencia,
    fechaInicial,
    fechaFinal,
    idUsuarioConsulta,
    idDistribuidora
  ): Observable<any> {
    const url =
      Constants.BASE_URL +
      Constants.URL_GESTION_VENDEDOR +
      "/" +
      idUsuario +
      "/" +
      agencia +
      "/" +
      fechaInicial +
      "/" +
      fechaFinal +
      "/" +
      idUsuarioConsulta +
      "/" +
      idDistribuidora;
    return this.http.get<any>(url /*, {headers:httpHeaders}*/).pipe(
      catchError((err) => {
        console.log(JSON.stringify(err));
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Gestión Vendedor",
            text: "Error Cargando Gestión Vendedor.",
            icon: "error",
          });
        }

        return throwError(err);
      })
    );
  }

  public getDetallePedido(idEncabezado): Observable<any> {
    const url =
      Constants.BASE_URL + Constants.URL_GESTION_VENDEDOR + "/" + idEncabezado;
    return this.http.get<any>(url /*, {headers:httpHeaders}*/).pipe(
      catchError((err) => {
        console.log(JSON.stringify(err));
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Gestión Vendedor",
            text: "Error Cargando Detalle Pedido.",
            icon: "error",
          });
        }

        return throwError(err);
      })
    );
  }

  public getConsultarPedido(idPedido, origen): Observable<any> {
    const url =
      Constants.BASE_URL +
      Constants.URL_GESTION_VENDEDOR +
      "/" +
      idPedido +
      "/" +
      origen;
    return this.http.get<any>(url /*, {headers:httpHeaders}*/).pipe(
      catchError((err) => {
        console.log(JSON.stringify(err));
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Picking",
            text: "Error Consultando Picking.",
            icon: "error",
          });
        }
        return throwError(err);
      })
    );
  }
  public setActualizarPedidoEstadoDespachado(dataDespacho){
    const url=
    Constants.BASE_URL +
      Constants.URL_GESTION_VENDEDOR +
      "/" +
      "ActualizarPedidoEstadoDespachado" +
      "/" ;
      return this.http.put<any>(url , dataDespacho).pipe(

        catchError((err) => {
          console.log(JSON.stringify(err));
          if (err.status === 401) {
            this.utils.cerrarSesion();
          } else {
            Swal.fire({
              title: "Error Actualizando Estado del despacho",
              text: "Error El estado no pudo ser modificado.",
              icon: "error",
            });
          }
          return throwError(err);
        })
      );
  }
  public setActualizarPedidoEstadoImpresion(dataImpresion){
    const url=
    Constants.BASE_URL +
      Constants.URL_GESTION_VENDEDOR +
      "/" +
      "ActualizarPedidoEstadoImpresion" +
      "/" ;
      return this.http.put<any>(url , dataImpresion).pipe(

        catchError((err) => {
          console.log(JSON.stringify(err));
          if (err.status === 401) {
            this.utils.cerrarSesion();
          } else {
            Swal.fire({
              title: "Error Actualizando Estado de Impresion",
              text: "Error El estado de impresion no pudo ser modificado.",
              icon: "error",
            });
          }
          return throwError(err);
        })
      );
  }
}
